import { render, staticRenderFns } from "./AddSchoolsComponents.vue?vue&type=template&id=6d4097be"
import script from "./AddSchoolsComponents.vue?vue&type=script&lang=js"
export * from "./AddSchoolsComponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports